import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewCreateAccountComponent } from './view-create-account/view-create-account.component';
import { ViewDashboardComponent } from './view-dashboard/view-dashboard.component';
import { PnelMyInstitutionComponent } from './pnel-my-institution/pnel-my-institution.component';
import { ViewMngInstInfoComponent } from './view-mng-inst-info/view-mng-inst-info.component';
import { ViewMngInstAccountsComponent } from './view-mng-inst-accounts/view-mng-inst-accounts.component';
import { ViewAllTestSessionsComponent } from './view-all-test-sessions/view-all-test-sessions.component';
import { ViewCtsTestWindowComponent } from './view-cts-test-window/view-cts-test-window.component';
import { ViewCtsLocationComponent } from './view-cts-location/view-cts-location.component';
import { FormSessionLocationComponent } from './form-session-location/form-session-location.component';
import { ViewCtsTechreadyComponent } from './view-cts-techready/view-cts-techready.component';
import { ViewCtsDatestimesComponent } from './view-cts-datestimes/view-cts-datestimes.component';
import { FormSessionTimeSlotsComponent } from './form-session-time-slots/form-session-time-slots.component';
import { FormSessionLocationTimeSlotsComponent } from './form-session-location-time-slots/form-session-location-time-slots.component';
import { WidgSessionCalendarComponent } from './widg-session-calendar/widg-session-calendar.component';
import { ViewCtsAccommodationsComponent } from './view-cts-accommodations/view-cts-accommodations.component';
import { ViewCtsRestrictedComponent } from './view-cts-restricted/view-cts-restricted.component';
import { ViewCtsMakeAvailableComponent } from './view-cts-make-available/view-cts-make-available.component';
import { PnelSessionsComponent } from './pnel-sessions/pnel-sessions.component';
import { ViewCtsInvitiationsComponent } from './view-cts-invitiations/view-cts-invitiations.component';
import { ViewManageSessionComponent } from './view-manage-session/view-manage-session.component';
import { ViewPendingAccommComponent } from './view-pending-accomm/view-pending-accomm.component';
import { PnelCtsChecklistComponent } from './pnel-cts-checklist/pnel-cts-checklist.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { UiPartialModule } from '../ui-partial/ui-partial.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgxMaskModule } from 'ngx-mask';
import { HttpClientModule } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { LinkBackToDashComponent } from './link-back-to-dash/link-back-to-dash.component';
import { ViewInvigComponent } from './view-invig/view-invig.component';
import { ViewPrintApplicantsComponent } from './view-print-applicants/view-print-applicants.component';

@NgModule({
  imports: [
    CommonModule,
    FullCalendarModule,
    RouterModule, 
    ReactiveFormsModule,
    UiPartialModule,
    NgxMaskModule,
    MarkdownModule,
  ],
  declarations: [
    ViewCreateAccountComponent, 
    ViewDashboardComponent, 
    PnelMyInstitutionComponent, 
    ViewMngInstInfoComponent, 
    ViewMngInstAccountsComponent, 
    ViewAllTestSessionsComponent, 
    ViewCtsTestWindowComponent, 
    ViewCtsLocationComponent, 
    FormSessionLocationComponent, 
    ViewCtsTechreadyComponent, 
    ViewCtsDatestimesComponent, 
    FormSessionTimeSlotsComponent, 
    FormSessionLocationTimeSlotsComponent, 
    WidgSessionCalendarComponent, 
    ViewCtsAccommodationsComponent, 
    ViewCtsRestrictedComponent, 
    ViewCtsMakeAvailableComponent, 
    PnelSessionsComponent, 
    ViewCtsInvitiationsComponent, 
    ViewManageSessionComponent, 
    ViewPendingAccommComponent, 
    PnelCtsChecklistComponent, LinkBackToDashComponent, ViewInvigComponent, ViewPrintApplicantsComponent,
  ],
})
export class UiTestadminModule { }
